import actions from './constants';

export const subscribeToRequestDatatsetSuccess = (category, code, datasetCode, { subscriptions }) => ({
  type: actions.SUBSCRIBE_TO_REQUEST_DATASET_SUCCESS, category, code, datasetCode, subscriptions,
});

export const subscribeToRequestDatatsetError = (category, code, error) => ({
  type: actions.SUBSCRIBE_TO_REQUEST_DATASET_ERROR,
  category,
  code,
  error,
});

export const fetchRequestUserSubscriptionsSuccess = (category, code, result) => ({
  type: actions.FETCH_REQUEST_USER_SUBSCRIPTIONS_SUCCESS, category, code, result,
});

export const fetchRequestUserSubscriptionsError = (category, code, error) => ({
  type: actions.FETCH_REQUEST_USER_SUBSCRIPTIONS_ERROR,
  category,
  code,
  error,
});
